'use client';

import { lazy, use, useRef } from 'react';
import AppUrlParams from '@frameio/shared/routing/params/params';

const QuickshareDialog = lazy(() => import('./QuickshareDialog'));

export function Quickshare() {
  const shareId = use(AppUrlParams.share);

  // lazy load the dialog when we actually show it
  // (we need to keep the dialog mounted after we show it, or we lose the
  // soft close animation)
  const hasEverShown = useRef(false);
  hasEverShown.current = Boolean(hasEverShown.current || shareId);
  return hasEverShown.current && <QuickshareDialog shareId={shareId} />;
}
